export enum AccountProfileComponents {
    Overview = 'AccountProfileView',
    Edit = 'AccountProfileEditDetails',
    ChangeEmail = 'AccountProfileChangeEmail',
    ChangePassword = 'AccountProfileChangePassword',
    Addresses = 'BillingProfileView',
    AddAddress = 'AccountProfileBillingAddress',
}
